import React from 'react';
import { Box, Typography } from '@mui/material';
import './SixthSection.scss';
import UnifiedButton from '../../shared/Button';
import PricingIcon from '../../../assets/Images/pricing 1st page.svg';
import SeeFull from '../../../assets/Images/see full plan 1st page.svg';
import { Slide } from 'react-awesome-reveal';
import { useNavigate } from 'react-router-dom';

const SIGN_UP_URL = 'https://app.fmdigitalofficial.com/sign-up';
const SALES_EMAIL = 'fmdigitalofficial@gmail.com';

// Mirrors the plan columns in PricingPage/SecondPricingSection.js — `id`
// is the /pricing/:id value that highlights this plan in the full table.
const plans = [
    {
        id: 1,
        variant: 'solo',
        title: 'Solo Creator',
        price: 'Free account for special request',
        description: 'Release to 190+ DSPs at no cost, use your own UPC & ISRC, and keep 70% of your royalties.',
        cta: 'Try For Free',
        action: 'signup',
    },
    {
        id: 2,
        variant: 'starter',
        title: 'Starter',
        price: '₹899 Per Release',
        description: 'Pay only when you release. 2-business-day delivery plus release edits, priced per release.',
        cta: 'Get Started',
        action: 'plan',
    },
    {
        id: 3,
        variant: 'career',
        title: 'Career Artist',
        price: 'Starting from ₹2999 onwards',
        priceDetail: '3 Labels | 10 Artists | 3 OAC | 95%',
        description: '10 artist profiles, official artist channels, playlist pitching, and 95% royalties paid every month.',
        cta: 'Get Started',
        action: 'plan',
    },
    {
        id: 4,
        variant: 'label',
        title: 'Label Executive',
        price: 'Starting from ₹12999 onwards',
        priceDetail: '15 Labels | 30 Artists | 15 OAC | 95%',
        description: 'Everything you need to run a label: 30 profiles, 15 labels, and a dedicated account manager.',
        cta: 'Kickstart Your Company',
        action: 'mail',
    },
];

function SixthSection() {

    const navigate = useNavigate(); // Initialize navigate hook

    const redirectToPricing = () => {
        window.scrollTo(0, 0);
        navigate('/pricing'); // Use navigate to go to the pricing page
    };

    const handlePlanClick = (plan) => () => {
        if (plan.action === 'signup') {
            window.location.href = SIGN_UP_URL;
            return;
        }
        if (plan.action === 'mail') {
            window.location.href = `mailto:${SALES_EMAIL}`;
            return;
        }
        // Land on the full table with this plan's column highlighted.
        navigate(`/pricing/${plan.id}`);
        window.scrollTo(0, 0);
    };

    return (
        <Box className="sixth-page">
            <Box className="pricing-icon-container">
                <img src={PricingIcon} alt="Pricing Icon" className="pricing-icon" />
                <Typography variant="h4" component="h2" className="pricing-title">
                    Pricing
                </Typography>
            </Box>
            <Slide direction="up" triggerOnce duration={1000} delay={200}>
                <Box className="cards-container">
                    {plans.map((plan) => (
                        <Box key={plan.id} className={`card ${plan.variant}`}>
                            <Typography variant="h5" component="h3" className="plan-title">
                                {plan.title}
                            </Typography>
                            <Typography variant="body2" className="plan-price">
                                {plan.price}
                                {plan.priceDetail && (
                                    <span className="plan-price-detail">{plan.priceDetail}</span>
                                )}
                            </Typography>
                            <Typography variant="body2" className="plan-description">
                                {plan.description}
                            </Typography>
                            <Box className="plan-button-wrap">
                                <UnifiedButton
                                    variant="contained"
                                    className="plan-button"
                                    textContent={plan.cta}
                                    onClick={handlePlanClick(plan)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box className="full-plans-container" onClick={redirectToPricing}>
                    <Typography variant="h6" className="full-plans-link">
                        See Full Plans
                    </Typography>
                    <img src={SeeFull} alt="See Full Plans" className="see-full-icon" />
                </Box>
            </Slide>
        </Box>
    );
}

export default SixthSection;
